import React, { useCallback, useEffect, useState } from "react";

import { Skeleton } from "@material-ui/lab";
import CreditCard from "react-credit-cards";
import { Button, Form, Icon, Loader } from "semantic-ui-react";
import swal from "sweetalert";
import Footer from "../../components/Footer";
import Topo from "../../components/Topo";

import { producaov2 as api } from "../../services/apis";
import { getNodeToken, getUserNode } from "../../services/auth_node";
import { limpaTituloCurso, verify_mobile } from "../../utils/Utils";
import { validatePayment } from '../../utils/validators';
import {
  formatCVC,
  formatCreditCardNumber,
  formatExpirationDate
} from "../InscricaoNode/utils";

import { FaCopy } from "react-icons/fa";
import { IoMdArrowBack } from "react-icons/io";
import InputMask from "react-input-mask";
import ProfileInfoValidator from "../../components/ProfileInfoValidator";
import {
  AmeIcon,
  BoletoDiv,
  Box,
  BoxRetorno,
  Card,
  CardsContainer,
  CenterContent,
  Container,
  ContainerPix,
  CreditCardDiv,
  Dimmer,
  Header,
  InputContainerPix,
  PicPayIcon,
  PixDesktop,
  PixMobile,
  QrCode,
  TutorialDesktopPix,
} from "./styles";

const ameCallback = 0.05;

const Pagar = (props) => {
  document.title = "Pagamento | Grupo Voitto";

  const [pedido, setPedido] = useState(undefined);
  const [pagamento, setPagamento] = useState();
  const [cartao, setCartao] = useState({
    name: "",
    number: "",
    expiry: "",
    cvc: "",
  });
  const [parcelas, setParcelas] = useState(false);
  const [focused, setFocused] = useState("name");
  const [loading, setLoading] = useState(true);
  const [pago, setPago] = useState(false);
  const [boleto, setBoleto] = useState("");
  const [subItem, setSubItem] = useState(false);
  const [multiplo, setMultiplo] = useState(false); //Variavel para controla se o pedido é um link de multiplos cursos
  const [userInfos, setUserInfos] = useState([]);
  const [isEmpVerifyCompra, setIsEmpVerifyCompra] = useState([]);
  const [ame, setAme] = useState({
    gerando: false,
    pronto: false,
    selecionado: false,
    link: undefined,
    qrcode: undefined,
  });
  const [picpay, setPicpay] = useState({
    gerando: false,
    pronto: false,
    selecionado: false,
    link: undefined,
    qrcode: {
      base64: "",
    },
  });
  const [picpayQrCode, setPicpayQrCode] = useState("");

  const [dadosIncompletos, setDadosIncompletos] = useState(false);
  const [pixQrCode, setPixQrCode] = useState(null);

  const [pagamentoEscolhido, setPagamentoEscolhido] = useState("");
  const [parcelasOptions, setParcelasOptions] = useState(
    Array(12)
      .fill(null)
      .map((v, i) => i + 1)
  );
  const [isExpired, setIsExpired] = useState(false);

  const options = ["boleto", "cartao_de_credito", "picpay", "ame", "pix"];

  const loadShopline = () => {
    window.open(
      "",
      "SHOPLINE",
      "toolbar=yes,menubar=yes,resizable=yes,status=no,scrollbars=yes,width=800,height=600,top=30,left=120"
    );
  };

  function redirectInscricao() {
    swal({
      title:
        "Você será redirecionado a página de inscrição para poder gerar outro QR code.",
      text: `Caso tenha algum problema contate voitto@voitto.com.br`,
      icon: "warning",
      buttons: true,
    }).then((res) => {
      if (res) {
        window.open(`/inscricao/${pedido.curso.id}`);
      }
    });
  }

  const handleInputCard = ({ target }) => {
    let value = target.value;

    if (target.name === "number") {
      target.value = formatCreditCardNumber(target.value);
    } else if (target.name === "expiry") {
      target.value = formatExpirationDate(target.value);
    } else if (target.name === "cvc") {
      target.value = formatCVC(target.value);
    }

    setCartao({ ...cartao, [target.name]: value });
  };

  const handleInputFocus = ({ target }) => {
    setFocused(target.name);
  };

  const handleChangeParcelas = useCallback(({ target }) => {
    setParcelas(target.value);
  }, []);

  const handleSubmitCard = async () => {
    if (!cartao.cvc || !cartao.expiry || !cartao.name || !cartao.number) {
      swal("Atenção", "Preencha todos dados do cartão", "warning");
      return;
    }
    const { id_pessoa, id_pedido, valor_pago, id_curso } = pedido;
    setLoading(true);

    const cursosWithMaterial = [{
      ...pedido.curso,
      materiais: pedido.pediu_material ? pedido.MaterialImpresso : null,
      certificados: pedido.pediu_certificado ? pedido.CertificadoImpresso : null
    }]

    const orderObject = await {
      ...pedido,
      cursos: cursosWithMaterial,
      pagamento: 'cartao_de_credito',
      cupom: '',
      total: valor_pago
    };

    const params = {
      data: new Date(),
      status: 70,
      tipo: 5,
      obs: '',
      valor_parcela: `{${parcelas}}x de ${valor_pago}`,
      json: JSON.stringify(orderObject),
      historico: pedido.pedido.historico
    };

    await api.put(`/pedido_inscricao/${id_pedido}`, params, {
      headers: {
        access_token: `voitto-token ${localStorage.getItem('oauth_token')}`
      }
    }).catch(err => {
      console.log(err);
      swal(
        `Algo deu errado`,
        `Se persistir, contate voitto@voitto.com.br`,
        "error"
      )
      return;
    })

    const [mes, ano] = cartao.expiry.split("/");

    const holderName = cartao.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

    const card = {
      number: cartao.number.replace(/\s/g, ''),
      holder_name: holderName,
      exp_month: mes,
      exp_year: ano,
      cvv: cartao.cvc
    }

    console.log(card);

    const creditCard = {
      recurrence: false,
      installments: parcelas,
      statement_descriptor: 'Voitto',
      card,
    }



    const card_params = {
      id_pedido,
      id_pessoa,
      isCompany: !!getUserNode()?.empresa?.url ? true : false,
      creditCard: creditCard,
      parcelas: parcelas,
      valor: valor_pago
    };

    await api.post('/pedidos-tentativa/create', {
        headers: {
          access_token: `voitto-token ${localStorage.getItem('oauth_token')}`
        }
      }
    )
    .then(res => {
      if (res?.data?.banned) {
        if(!!getUserNode()?.empresa?.url){
          window.location.href = `https://www.voitto.com.br/painel-corporativo/empresa`;
        }
        window.location.href = '';
      }
    })
    .catch(err => {
      console.error(`checkErro: ${err}`);
    });
    let message = null;

    await api.post('pedido/pagamentos', card_params).then((async (res) => {
      if (res.data.item.orderStatus == 'failed') {
        message = 'Ocorreu um erro com os dados do seu cartão. Por favor revise e tente novamente.';
        return message;
      }

      let myInterval = null;

      const loopPayment = async (id_pedido, response, courseId, card_params, message) => {
        return new Promise((resolve) => {
          myInterval = setInterval(async () => {
            const paymentResponse = await validatePayment(id_pedido, response, courseId, card_params, message);
            if (paymentResponse != 'invalido') {
              return resolve(paymentResponse);
            }
          }, 1500);
        });
      };

      const validate = await loopPayment(id_pedido, res, id_curso, card_params, message);
      if (myInterval) {
        clearInterval(myInterval);
      }

      message = validate;

    })).catch((err) => {
      setLoading(false);
      swal(
        `Algo deu errado`,
        `Se persistir, contate voitto@voitto.com.br`,
        "error"
      );
    })

    if (message === 'success') {
      if(getUserNode()?.empresa?.url){
        window.location.href = `https://www.voitto.com.br/painel-corporativo/empresa`;
        return;
      }
      window.location.href = `/inscricao/confirmacao/${id_curso}?id_pessoa=${id_pessoa}`;
      return;
    }
    swal(
      message,
      `Se persistir, contate voitto@voitto.com.br`,
      "error"
    );

    setLoading(false);
  };

  //VERIFICACAO LINK PAGAMENTO
  function reformDataPedidoIfLink(data) {
    let retorno = data;
    let newTotal = 0;
    data.map((v) => {
      newTotal += v.valor_pago;
    });
    retorno[0].valor_final = newTotal;
    return retorno;
  }
  useEffect(() => {

    if(!getNodeToken()){
      localStorage.setItem("redirect", window.location.pathname);
      window.location.href = "/login";
      return;
    }else{

      api
        .get(`/pessoa/pedido/${props.match.params.pedido}`)
        .then((res) => {
          const [response] = res.data;
          if (
            response?.pedido?.json?.pagamento &&
            response?.pedido?.json?.pagamento !== "escolha" &&
            response?.pedido?.json?.pagamento !== "free" &&
            response?.pedido?.json?.pagamento !== "LINK GERADO"
          ) {
            setPagamentoEscolhido(response?.pedido?.json?.pagamento);
          }
  
          if (res.data.length >= 2) {
            setMultiplo(true);
            setPedido(reformDataPedidoIfLink(res.data));
          } else {
            setPedido(response);
            setSubItem(response.isSubitem);
          }
  
          if (response.status === 3) {
            swal(
              "Esse pedido já foi pago!",
              "Estamos te redirecionando para os seus cursos. Em caso de dúvidas, entre em contato com o suporte",
              "success"
            ).then(() => {
              window.location.href = "/meu-aprendizado";
            });
          }
  
          if (res.data[0].pedido.json?.dataValidadePedido && new Date(res.data[0].pedido.json?.dataValidadePedido) < new Date()) {
            setIsExpired(true);
            swal("Esse pedido expirou", "Por favor, entre em contato com o nosso suporte para verificar a vigência dessa oferta.", "error", {
              buttons: {
                cancel: "Cancelar",
                suport: {
                  text: "Entrar em contato com suporte",
                  value: "suporte",
                },
              },
            })
              .then((value) => {
                if (value === 'suporte') {
                  window.location.assign("https://api.whatsapp.com/send?phone=5521998386865&text=Ol%C3%A1,%20gostaria%20de%20saber%20uma%20informação%20sobre%20a%20Voitto.");
                  return
                };
                window.location.href = "/";
              });
          };
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          if (err.response) {
            if (err.response.status === 401) {
              localStorage.setItem("redirect", window.location.pathname);
              window.location.href = "/login";
            } else {
              swal(
                "Pedido não encontrado",
                "Estamos te redirecionando para os seus pedidos",
                "error"
              ).then(() => {
                window.location.href = "/online/historico";
              });
            }
          } else {
            swal(
              "Ocorreu um erro!",
              "Estamos te redirecionando para os seus pedidos. \nCaso o erro persista, contate nosso suporte",
              "error"
            ).then(() => {
              window.location.href = "/online/historico";
            });
          }
        });
    }
  }, []);

  useEffect(() => {
    updatePedidoPagamento(pagamento);
  }, [pagamento]);

  const getInitialParcelas = useCallback(() => {
    if (!pedido) {
      return;
    }

    const firstPedido = Array.isArray(pedido) ? pedido[0] : pedido;
    const json =
      typeof firstPedido.pedido.json !== "object"
        ? JSON.parse(firstPedido.pedido.json)
        : firstPedido.pedido.json;

    if (json.parcelas) {
      setParcelas(json.parcelas);
      setParcelasOptions(
        Array(Number(json.parcelas))
          .fill(null)
          .map((v, i) => i + 1)
      );
    }
  }, [pedido]);

  useEffect(() => {
    setIsEmpVerifyCompra(localStorage.getItem("IS_EMP_PAYMENT"))
    getInitialParcelas();
  }, [pedido]);

  const numberToString = (number) => {
    let numberUse = number.toFixed(2);
    return numberUse.replace(".", ",");
  };

  function renderContainerUniqueCourse() {
    return (
      pedido && (
        <>
          <br />
          <p>
            {" "}
            <strong> Curso:</strong> {limpaTituloCurso(pedido.curso.curso)}
            <br />
            <br />{" "}
            {pedido.isSubitem && (
              <>
                <strong>Obs:</strong> Material e/ou Certificado <br />
                <br />
              </>
            )}{" "}
            <strong>Valor:</strong> R${pedido.valor_pago}{" "}
          </p>
        </>
      )
    );
  }

  function returnNameCourses() {
    return pedido.map((pedido) => (
      <p style={{ width: "100%", textAlign: "center" }}>
        {limpaTituloCurso(pedido.curso.curso)}
        <br />
        {pedido.isSubitem && (
          <>
            <strong>Obs:</strong> Material e/ou Certificado <br />
            <br />
          </>
        )}
        <strong>Valor:</strong> R${pedido.valor_pago}
      </p>
    ));
  }

  function totalMultiCourser() {
    let total = 0;
    if (pedido) {
      pedido.map((pedido) => {
        total += pedido.valor_pago;
      });
    }
    return total;
  }

  function renderContainerMultiCourses() {
    return (
      pedido && (
        <>
          <p style={{ width: "100%", textAlign: "center", fontSize: 20 }}>
            <b>Total: </b>R${totalMultiCourser().toFixed(2)}
          </p>
          <strong> Cursos:</strong>
          {returnNameCourses()}
        </>
      )
    );
  }

  function gerarPagamentoAme() {
    setPagamento("ame");
    setLoading(true);
    ame.gerando = true;
    setAme(ame);

    api
      .post(`ame/createOrder`, {
        id_curso: pedido.curso.id,
        curso: pedido.curso.curso,
        total: multiplo === false ? pedido.valor_pago : totalMultiCourser(),
        id_pedido: pedido.pedido.id,
        cep: userInfos.cep,
        endereco: userInfos.endereco,
        numero: userInfos.numero,
        complemento: userInfos.complemento,
        bairro: userInfos.bairro,
        cidade: userInfos.cidade,
        estado: userInfos.estado,
      })
      .then((res) => {
        const { ameOrder } = res.data;
        ame.gerando = false;
        ame.pronto = true;
        ame.link = ameOrder.deepLink;
        ame.qrcode = ameOrder.qrCodeLink;
        setLoading(false);
        setAme(ame);
        setInterval(() => {
          api.get(`/ame/pedido/${pedido.pedido.id}`).then((res) => {
            const { status } = res.data;
            if (
              status == "SUCCESS" ||
              status == "SUCCESS".toLocaleLowerCase()
            ) {
              swal(
                "Recebemos seu pagamento e estamos te redirecionando...",
                "",
                "success"
              ).then(() => {
                if(isEmpVerifyCompra){
                  window.location.href = `https://www.voitto.com.br/painel-corporativo/empresa`;
                  return;
                }
                window.location.href = `/inscricao/confirmacao/${pedido.curso.id}?id_pessoa=${getUserNode().id}`;

              });
              setTimeout(() => {
                if(isEmpVerifyCompra){
                  window.location.href = `https://www.voitto.com.br/painel-corporativo/empresa`;
                  return;
                }
                window.location.href = `/inscricao/confirmacao/${pedido.curso.id}?id_pessoa=${getUserNode().id}`;

              }, 5000);
            }
          });
        }, 1500);
      })
      .catch((err) => {
        setLoading(false);
        swal(
          "",
          "Houve um erro com os servidores da Ame, tente novamente.",
          "error"
        );
      });
  }

  function gerarPagamentoPicPay() {
    setLoading(true);
    setPagamento("picpay");
    const picpayNew = picpay;
    picpayNew.gerando = true;
    setPicpay(picpayNew);

    let params = {
      referenceId: null,
      callbackUrl: null,
      returnUrl: null,
      value: null,
      expiresAt: null,
      buyer: {
        firstName: userInfos.nome,
        lastName: userInfos.sobrenome,
        document: userInfos.cpf,
        email: userInfos.email,
        phone: userInfos.celular,
      },
    };

    params.referenceId = pedido.pedido.id;
    params.callbackUrl = `https://apiv2.voitto.com.br/v2/picpay/changestatus/${pedido.pedido.id}`;
    params.returnUrl = isEmpVerifyCompra ? `https://www.voitto.com.brhttps://www.voitto.com.br/painel-corporativo/empresa`: `https://www.voitto.com.br/inscricao/confirmacao/${pedido.pedido.id}`;
    params.value = multiplo === false ? pedido.valor_pago : totalMultiCourser();

    let atualDate = new Date();
    atualDate.setMinutes(atualDate.getMinutes() + 1);
    params.expiresAt = atualDate;
    params = JSON.stringify(params);

    const paramsPicpay = {
      id_pedido: pedido.pedido.id,
      id_pessoa: getUserNode().id,
      id_curso: pedido.curso.id,
      id_pessoa_curso: 0,
      status: "created",
      json: "{}",
      pessoa: getUserNode().id,
      curso: pedido.curso.id,
    };

    api
      .post(`picpay`, paramsPicpay)
      .then((picpaycreate) => {
        api
          .post(`https://appws.picpay.com/ecommerce/public/payments`, params, {
            headers: {
              "x-picpay-token": "f947cd04-9faf-4f1b-9397-a6cd9dd6e08a",
              "x-seller-token": "24c4486b-46c4-458f-9d32-5bbd20171b5d",
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            setLoading(false);
            const picpayFinaly = picpay;
            const qrcodePic = res.data.qrcode;
            picpayFinaly.gerando = false;
            picpayFinaly.pronto = true;
            picpayFinaly.link = res.data.paymentUrl;
            picpayFinaly.qrcode = qrcodePic;
            setTimeout(() => {
              setPicpay(picpayFinaly);
              setPicpayQrCode(res.data.qrcode.base64);
            }, 1000);
            setInterval(() => {
              api
                .get(`/picpay/${picpaycreate.data.pedido.id}`,{
                  headers: {
                    access_token: `voitto-token ${localStorage.getItem('oauth_token')}`
                  }
                })
                .then((response) => {
                  const { status } = response.data;
                  if (
                    status == "SUCCESS" ||
                    status == "SUCCESS".toLocaleLowerCase()
                  ) {
                    swal(
                      "Recebemos seu pagamento e estamos te redirecionando...",
                      "",
                      "success"
                    ).then(() => {
                      if(isEmpVerifyCompra){
                        window.location.href = `https://www.voitto.com.br/painel-corporativo/empresa`;
                        return;
                      }
                      window.location.href = `/inscricao/confirmacao/${pedido.curso.id}?id_pessoa=${getUserNode().id}`;

                    });
                    setTimeout(() => {
                      if(isEmpVerifyCompra){
                        window.location.href = `https://www.voitto.com.br/painel-corporativo/empresa`;
                        return;
                      }
                      window.location.href = `/inscricao/confirmacao/${pedido.curso.id}?id_pessoa=${getUserNode().id}`;

                    }, 5000);
                  }
                });
            }, 1500);
          })
          .catch((err) => {
            setLoading(false);
            swal(
              "",
              "Houve um erro com os servidores do PicPay, tente novamente.",
              "error"
            );
          });
      })
      .catch((err) => {
        setLoading(false);
        swal(
          "Não foi possível criar o pedido PicPay na nossa base de dados.",
          `Tente novamente, se persistir entre em contato com voitto@voitto.com.br`,
          "error"
        );
      });
  }

  const updatePedidoPagamento = useCallback(
    (metodo) => {
      if (!pedido || !pedido.pedido) {
        return;
      }

      const json = pedido.pedido.json;

      json.pagamento = metodo;

      return api
        .put(`/pedido_inscricao/${pedido.pedido.id}`, {
          ...pedido.pedido,
          json: JSON.stringify(json),
        })
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          console.error(err);
          return false;
        });
    },
    [pedido]
  );

  const gerarPagamentoPix = async () => {
    setPagamento("pix");
    const { id, id_curso, id_pessoa, id_pedido } = pedido;

    const paramsPixCreatePedido = {
      id_pedido,
      id_pessoa,
      id_curso,
      id_pessoa_curso: id,
      status: 'created',
      json: '{}',
      pessoa: id_pessoa,
      curso: id_curso
    };

    await api.post('/pix/create', paramsPixCreatePedido, {
      headers: {
        access_token: `voitto-token ${localStorage.getItem('oauth_token')}`
      }
    }).then(() => {
      api.post('pedido/pagamentos', {
        id_pedido,
        id_pessoa
      },
        {
          headers: {
            access_token: `voitto-token ${localStorage.getItem('oauth_token')}`
          }
        }
      ).then(res => {
        const newData = res.data;

        if (newData.status === 'erro' || newData.item.orderStatus === 'failed') {
          return false;
        }
        const { qrCodeUrl, qrCode } = newData.item;

        setPixQrCode({ qrCodeUrl, qrCode });

        let ok = false;

        setInterval(() => {

          if (ok) return false;
          api.post(`/pix/pedido/${pedido.pedido.id}`, {
            headers: {
              access_token: `voitto-token ${localStorage.getItem(
                'oauth_token'
              )}`
            }
          }).then(async res => {
            const { status } = res.data;

            if (status !== 'SUCCESS' && status !== 'SUCCESS'.toLocaleLowerCase()) {
              return false;
            }

            ok = true;

            await api.post('/pagamento/certificadoPending', {
              id_pedido,
              id_curso
            }, {
              headers: {
                access_token: `voitto-token ${localStorage.getItem(
                  'oauth_token'
                )}`
              }
            });

            await api.post("bank/purchase/", {
              id_pessoa: id_pessoa,
              valor: pedido.pedido.json.desconto * 10 || 0,
            }).then(() => {
              if(isEmpVerifyCompra){
                window.location.href = `https://www.voitto.com.br/painel-corporativo/empresa`;
                return;
              }
              window.location.href = `/inscricao/confirmacao/${id_curso}?id_pessoa=${id_pessoa}`;

            }).catch(() => {
              if(isEmpVerifyCompra){
                window.location.href = `https://www.voitto.com.br/painel-corporativo/empresa`;
                return;
              }
              window.location.href = `/inscricao/confirmacao/${id_curso}?id_pessoa=${id_pessoa}`;

            })

            api.post(`academy/cursos/${id_curso}/enviar-email/112`, {})
              .catch((err) => console.error(err));
          })

        }, 1500)
      }).catch((err) => {
        swal(
          "",
          "Houve um erro com os servidores, tente novamente.",
          "Tente novamente, se persistir entre em contato com voitto@voitto.com.br",
          "error"
        );
      })

    }).catch((err) => {
      setLoading(false);
      swal(
        "",
        "Houve um erro com os servidores do pix, tente novamente.",
        "error"
      );
    })
  }

  return (
    <>
      <Topo />
      {loading && (
        <Dimmer>
          <Loader active inline="centered">
            Carregando Dados...
          </Loader>
        </Dimmer>
      )}
      <Container>
        <ProfileInfoValidator
          dadosIncompletos={dadosIncompletos}
          setDadosIncompletos={setDadosIncompletos}
          setUserInfos={(dados) => setUserInfos(dados)}
        />

        {!isExpired &&
          <Box>
            {(pagamentoEscolhido !== "" || pagamento) && (
              <BoxRetorno>
                <IoMdArrowBack
                  onClick={() => {
                    setPagamentoEscolhido("");
                    setPagamento(null);
                  }}
                />
              </BoxRetorno>
            )}

            {!pagamento && (
              <>
                <Header>PAGAMENTO</Header>
                {multiplo === false
                  ? renderContainerUniqueCourse()
                  : renderContainerMultiCourses()}

                {!loading && (
                  <CardsContainer>
                    {/* {(!pagamentoEscolhido || pagamentoEscolhido === "boleto") && (
                      <Card
                        onClick={() => {
                          if (!dadosIncompletos) {
                            gerarBoleto();
                            return;
                          }

                          swal("", "Infome seus dados completos.");
                        }}
                      >
                        <div>
                          <Icon size="huge" name="barcode" />
                        </div>
                        <p>Boleto</p>
                      </Card>
                    )} */}
                    {(!pagamentoEscolhido ||
                      pagamentoEscolhido === "cartao_de_credito") && (
                        <Card
                          onClick={() => {
                            if (!dadosIncompletos) {
                              setPagamento("cartao_de_credito");
                              return;
                            }

                            swal("", "Infome seus dados completos.");
                          }}
                        >
                          <div>
                            <Icon size="huge" name="credit card outline" />
                          </div>
                          <p>Cartão de Crédito</p>
                        </Card>
                      )}

                    {(!pagamentoEscolhido || pagamentoEscolhido === "picpay") && (
                      <Card
                        onClick={() => {
                          if (!dadosIncompletos) {
                            gerarPagamentoPicPay();
                            return;
                          }

                          swal("", "Infome seus dados completos.");
                        }}
                      >
                        <div>
                          <PicPayIcon
                            src={
                              "https://files.voitto.com.br/picpay-logo.webp"
                            }
                          />
                        </div>
                        <p>Picpay</p>
                      </Card>
                    )}
                    {/* {(!pagamentoEscolhido || pagamentoEscolhido === "ame") && (
                    <Card
                      onClick={() => {
                        if (!dadosIncompletos) {
                          gerarPagamentoAme();
                          return;
                        }

                        swal("", "Infome seus dados completos.");
                      }}
                    >
                      <div>
                        <AmeIcon src="https://files.voitto.com.br/ame-icon.png" />
                      </div>
                      <p>AME</p>
                    </Card>
                  )} */}

                    {(!pagamentoEscolhido || pagamentoEscolhido === "pix") && (
                      <Card
                        onClick={() => {
                          if (!dadosIncompletos) {
                            gerarPagamentoPix();
                            return;
                          }

                          swal("", "Infome seus dados completos.");
                        }}
                      >
                        <div>
                          <AmeIcon src="https://files.voitto.com.br/logos/logopix.png" />
                        </div>
                        <p>PIX</p>
                      </Card>
                    )}
                  </CardsContainer>
                )}
              </>
            )}
            {pagamento === "cartao_de_credito" && (
              <>
                <Header>PAGAMENTO</Header>
                <CreditCardDiv>
                  <CreditCard
                    placeholders={{ name: "NOME NO CARTÃO" }}
                    number={cartao.number}
                    name={cartao.name}
                    expiry={cartao.expiry}
                    cvc={cartao.cvc}
                    focused={focused}
                  />
                  <Form style={{ marginTop: "50px" }}>
                    <Form.Field>
                      <label>Parcelas</label>
                      <select
                        onChange={(e) => handleChangeParcelas(e)}
                        class="ui fluid dropdown"
                        value={parcelas}
                      >
                        <option value={""}>Escolha o número de parcelas</option>
                        {parcelasOptions.map((v) => (
                          <option value={v} name="parcelas">
                            {v}x de R$
                            {numberToString(
                              (multiplo === false
                                ? pedido.valor_pago
                                : totalMultiCourser()) / v
                            )}
                          </option>
                        ))}
                      </select>
                    </Form.Field>
                    <Form.Field className="field form-group">
                      <label>Número no cartão de crédito:</label>
                      <input
                        type="tel"
                        id="numero_cartao"
                        name="number"
                        className="form-control"
                        placeholder="0000 0000 0000 0000"
                        pattern="[\d| ]{16,22}"
                        onChange={(e) => handleInputCard(e)}
                        onFocus={(e) => handleInputFocus(e)}
                        maxLength={19}
                      />
                    </Form.Field>
                    <Form.Field className="field form-group">
                      <label>Nome no cartão de crédito:</label>
                      <input
                        type="text"
                        id="nome_cartao"
                        name="name"
                        className="form-control"
                        placeholder="VOITTO TREINAMENTOS"
                        onChange={(e) => handleInputCard(e)}
                        onFocus={(e) => handleInputFocus(e)}
                        maxLength={25}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Data de validade:</label>
                      <input
                        type="tel"
                        name="expiry"
                        id="data_validade"
                        className="form-control"
                        placeholder="mês/ano"
                        pattern="\d\d/\d\d"
                        onChange={(e) => handleInputCard(e)}
                        onFocus={(e) => handleInputFocus(e)}
                        maxLength={5}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>CVC:</label>
                      <input
                        type="tel"
                        name="cvc"
                        placeholder="1234"
                        pattern="\d{3,4}"
                        onChange={(e) => handleInputCard(e)}
                        onFocus={(e) => handleInputFocus(e)}
                        onSubmit={handleSubmitCard}
                        maxLength={4}
                      />
                    </Form.Field>
                    <center>
                      <Button
                        onClick={handleSubmitCard}
                        disabled={pago}
                        loading={loading}
                        primary
                      >
                        Confirmar
                      </Button>
                    </center>
                  </Form>
                </CreditCardDiv>
              </>
            )}
            {pagamento === "picpay" && (
              <div>
                <div className="ui divider"></div>
                <div className="picpay-explicacao">
                  {picpay.gerando === false && picpay.pronto === false ? (
                    <CenterContent>
                      <Skeleton variant="rect" width={200} height={200} />
                    </CenterContent>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <p>
                        Para concluir pague diretamente via QR Code ou acesse o
                        site do picpay:
                      </p>
                      {picpayQrCode !== "" && (
                        <img
                          class="qrcode"
                          src={picpayQrCode}
                          alt="QR Code PicPay"
                        />
                      )}
                      <button
                        style={
                          verify_mobile()
                            ? { marginTop: "5%" }
                            : { marginTop: "2%" }
                        }
                        onClick={() => window.open(picpay.link, "_self")}
                        class="ui big green button"
                      >
                        Acessar PicPay
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
            {pagamento === "boleto" && (
              <>
                <Header>Confirmar Pagamento</Header>
                <BoletoDiv>
                  <p>
                    Clique no botão abaixo para ser redirecionado ao Itaú Shopline
                    e gerar seu boleto.
                  </p>
                  <form
                    method="post"
                    action={"https://shopline.itau.com.br/shopline/shopline.aspx"}
                    target={"SHOPLINE"}
                    onSubmit={() => loadShopline()}
                    style={{ textAlign: "center" }}
                  >
                    <input type="hidden" name="DC" value={boleto} />
                    <input
                      type={"image"}
                      className="my-payment-itau"
                      name="Shopline"
                      value={"Itaú Shopline"}
                      src={
                        "https://files.voitto.com.br/ftp-files/assets/images/btn-itau-bline.gif"
                      }
                    />
                  </form>
                </BoletoDiv>
              </>
            )}
            {/* {pagamento === "ame" && (
            <>
              <div style={{ textAlign: "center" }}>
                <p>
                  A ame é o app para você pagar suas compras e ganhar dinheiro
                  de volta. Você escolhe se quer pagar com cartão, com o saldo
                  acumulado ou com cartão + saldo! Baixe o app e crie sua conta.
                </p>
                <p>
                  Nesse pedido, você pagará R$
                  {multiplo === false
                    ? pedido.valor_pago
                    : totalMultiCourser()}{" "}
                  e{" "}
                  <b>
                    receberá R$
                    {numberToString(
                      (multiplo === false
                        ? pedido.valor_pago
                        : totalMultiCourser()) * ameCallback
                    )}{" "}
                    de volta!
                  </b>
                </p>
                <div class="ame-qrcode-wrapper">
                  <img
                    src="https://api.amedigital.com/vtex-checkout/images/logo-ame.svg"
                    class="logo"
                    alt="Ame digital"
                  />
                  <div class="container">
                    <div class="payment-values">
                      {" "}
                      <strong>Valor da compra:</strong>
                      <strong>
                        <span>
                          R${" "}
                          {numberToString(
                            multiplo === false
                              ? pedido.valor_pago
                              : totalMultiCourser()
                          )}
                        </span>
                      </strong>
                      <p>
                        Receba de volta{" "}
                        <strong>
                          R${" "}
                          {numberToString(
                            (multiplo === false
                              ? pedido.valor_pago
                              : totalMultiCourser()) * ameCallback
                          )}
                        </strong>{" "}
                        em até 30 dias.
                      </p>
                    </div>
                    <img
                      class="qrcode"
                      src={ame.qrcode}
                      alt="QR Code Ame Digital"
                    />
                    <div class="payment-info">
                      {" "}
                      <strong>Pagar com a AME é mais fácil e rápido!</strong>
                      <ul>
                        <li>
                          1. Abra o aplicativo Ame Digital. Se você ainda
                          <p>
                            {" "}
                            <strong>não tem, baixe no</strong>
                            <img
                              src="https://api.amedigital.com/vtex-checkout/images/google-logo.svg"
                              alt="Google Play"
                            />{" "}
                            <strong>ou na</strong>
                            <img
                              src="https://api.amedigital.com/vtex-checkout/images/apple-logo.svg"
                              alt="App Store"
                            />
                          </p>
                        </li>
                        <li>
                          <p>
                            2. Clique em <strong>pagar</strong>
                            <img
                              src="https://api.amedigital.com/vtex-checkout/images/ame-small-logo.svg"
                              alt="Ame Logo"
                            />
                            e aponte para o QR Code.
                          </p>
                        </li>
                        <li>
                          3. Pronto, agora é só finalizar o pagamento com{" "}
                          <strong>Ame</strong>.
                        </li>
                      </ul>{" "}
                      <a href="https://www.amedigital.com/" target="_blank">
                        Quer saber mais sobre a Ame? Clique aqui.
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )} */}
            {pagamento === "pix" && (pixQrCode ? (
              <>
                <ContainerPix>
                  <PixDesktop>
                    <TutorialDesktopPix>
                      <div>
                        <p>
                          {" "}
                          1. Abra o app ou banco de sua preferência. Escolha a
                          opção pagar com o Pix "copia e cola" ou código QR.
                        </p>
                      </div>
                      <div>
                        <p>
                          {" "}
                          2. Copie e cole o código, ou escaneie o codigo QR com a
                          câmera do seu celular. Confira todas as informações e
                          autorize o pagamento.
                        </p>
                      </div>
                      <div>
                        <p>
                          {" "}
                          3. Você vai receber a confirmação do pagamento no seu
                          e-mail. E pronto!
                        </p>
                      </div>
                    </TutorialDesktopPix>
                    {pixQrCode.qrCodeUrl !== "" ? (
                      <QrCode>
                        <img
                          src={pixQrCode.qrCodeUrl}
                          width="200"
                          height="200"
                        />
                      </QrCode>
                    ) : (
                      <CenterContent>
                        <Skeleton variant="rect" width={200} height={200} />
                      </CenterContent>
                    )}
                    <strong>
                      R${" "}
                      {numberToString(
                        multiplo === false
                          ? pedido.valor_pago
                          : totalMultiCourser()
                      )}
                    </strong>

                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(pixQrCode.qrcode);
                        swal(
                          "Copiado",
                          "O código foi copiado com sucesso!",
                          "success"
                        );
                      }}
                    >
                      <FaCopy />
                      <span>Copiar código do QR Code</span>
                    </button>
                    <p>
                      <b>
                        Se o pagamento não for confirmado, não se preocupe. O
                        pedido será cancelado automaticamente.
                      </b>
                    </p>
                  </PixDesktop>
                  <PixMobile>
                    <h3>1. Copie o código no botão abaixo</h3>
                    {pixQrCode.imagemQrcode !== "" ? (
                      <>
                        <InputContainerPix>
                          <InputMask
                            placeholder="Pix code"
                            enabled={false}
                            value={pixQrCode.qrcode}
                            type="text"
                          />
                        </InputContainerPix>
                        <button
                          onClick={() => {
                            navigator.clipboard.writeText(pixQrCode.qrCode);
                            swal(
                              "Copiado",
                              "O código foi copiado com sucesso!",
                              "success"
                            );
                          }}
                        >
                          <FaCopy />
                          <span>Copiar código do QR Code</span>
                        </button>
                        <h3>
                          2. Abra o app ou banco de sua preferência.
                          <br />
                          Escolha a opção pagar com o Pix "copia e cola"
                        </h3>
                        <h3>
                          3. Escolha a opção "Pix copia e cola" no app escolhido
                          da sua instituição financeira. Cole o código e autorize
                          o pagamento.
                        </h3>
                        <h3>
                          4. Você vai receber a confirmação do pagamento no seu
                          e-mail. E pronto!
                        </h3>
                        <h3>
                          <b>
                            Se o pagamento não for confirmado, não se preocupe. O
                            pedido será cancelado automaticamente.
                          </b>
                        </h3>
                      </>
                    ) : (
                      <CenterContent>
                        <Skeleton variant="rect" width={200} height={200} />
                      </CenterContent>
                    )}
                  </PixMobile>
                </ContainerPix>
              </>
            ) : (
              <Dimmer>
                <Loader active inline="centered">
                  Carregando Dados...
                </Loader>
              </Dimmer>
            ))}
          </Box>}
      </Container>
      <Footer />
    </>
  );
};

export default Pagar;
